<template>
  <div class="add-button">
    <v-btn
      class="add-button__button"
      fab
      dark
      fixed
      right
      medium
      color="indigo"
      @click="emitClick"
    >
      <v-icon large>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "AddButton",

  methods: {
    emitClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
.add-button {
  position: relative;
  width: 100vw;
  height: 100vh;
}

.add-button__button {
  bottom: 80px;
}
</style>
